import React from 'react';
import SaisieLibreComponent
  from '../../../../components/Mouvement/Panel/InformationsRattachement/SaisieLibreComponent';
import InformationsRattachementPanel from '../InformationsRattachementPanel';

class SaisieLibrePanel extends InformationsRattachementPanel {
  getComponent = function getComponent(
    data: any,
    onChange: any,
    handlePin: any,
  ): React.ReactElement {
    return (
      <SaisieLibreComponent
        data={data}
        handlePin={handlePin}
        onChange={onChange}
        panel={this}
      />
    );
  };
}

export default SaisieLibrePanel;
